<template>
  <v-img  src="/img_welcome.jpg"
  max-height=600
  cover>
    <div class="middle">
      {{title}}
    </div>
  </v-img>
</template>
    
<script>
  import mixinAppName from '@/mixins/appName'
  
  export default {
    data () {
      return { 
        title:"",
      }
    },
    mixins: [mixinAppName],
    created(){
      if(this.isAyresgroupPortal())
        this.title = "Ayres Presentations Portal"
      if(this.isAyresInstitutionalPortal())
        this.title = "Ayres Institutional Portal";
      if(this.isAyresResearchPortal())
        this.title = "Ayres Research Portal"
    }
  }
</script>
<style>
  .middle {    
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: darkblue;
    font-size:xx-large;
    padding-top: 5%;
  }
</style>